export default __webpack_public_path__ + "static/media/dot.77155ff0.svg";